// extracted by mini-css-extract-plugin
export var externalLink = "_dk-0";
export var internalLinkLabel = "_dk-1";